import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import './LetterForm.css';

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function LetterForm({ onSubmitSuccess }) {
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [isPrivate, setIsPrivate] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [alreadySent, setAlreadySent] = useState(false);

  const getClientIp = async () => {
    try {
      const res = await fetch('https://api.ipify.org?format=json');
      const data = await res.json();
      return data.ip;
    } catch {
      return 'unknown';
    }
  };

  const getTodayDateRange = () => {
    const now = new Date();
    const startUTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    const endUTC = new Date(startUTC);
    endUTC.setUTCDate(endUTC.getUTCDate() + 1);

    return {
      start: startUTC.toISOString(),
      end: endUTC.toISOString(),
    };
  };

  const alreadySentToday = async (clientId) => {
    const { start, end } = getTodayDateRange();
    const { data } = await supabase
      .from('letters')
      .select('id')
      .eq('client_id', clientId)
      .gte('created_at', start)
      .lt('created_at', end);

    return data && data.length > 0;
  };

  useEffect(() => {
    const checkDailyLimit = async () => {
      let clientId = localStorage.getItem('client_id');
      if (!clientId) {
        clientId = generateUUID();
        localStorage.setItem('client_id', clientId);
      }
      const hasSent = await alreadySentToday(clientId);
      setAlreadySent(hasSent);
    };
    checkDailyLimit();
  }, []);

  const handlePreSubmit = (e) => {
    e.preventDefault();
    if (!message || alreadySent) return;
    setShowConfirm(true);
  };

  const handleConfirmSubmit = async () => {
    setSubmitting(true);
    setShowConfirm(false);

    let clientId = localStorage.getItem('client_id');
    if (!clientId) {
      clientId = generateUUID();
      localStorage.setItem('client_id', clientId);
    }

    const ip = await getClientIp();

    const { error } = await supabase.from('letters').insert([
      {
        name: name || 'Kage',
        message,
        ip_address: ip,
        client_id: clientId,
        is_private: isPrivate,
      },
    ]);

    if (!error) {
      setName('');
      setMessage('');
      setIsPrivate(false);
      setAlreadySent(true);
      onSubmitSuccess?.();
    } else {
      alert('편지 저장 실패: ' + error.message);
    }

    setSubmitting(false);
  };

  return (
    <section className="letter-form">
      <div className="letter-divider-preview">
        <span className="letter-from">{name || 'Kage'}</span>
        <div className="letter-line" />
        <span className="letter-divider-text">letter to</span>
        <div className="letter-line" />
        <span className="letter-to">KOIRO</span>
      </div>

      <form className="letter-form-body" onSubmit={handlePreSubmit}>
        <div className="letter-field">
          <label htmlFor="name" className="letter-label">
            보내는 이
          </label>
          <input
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="letter-input"
            placeholder="이름을 입력하세요"
          />
          <p className="letter-helper">→ 그림자처럼 남기고 싶다면 비워두셔도 괜찮아요</p>
        </div>

        <div className="letter-field">
          <label htmlFor="message" className="letter-label">
            편지 내용
          </label>
          <textarea
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
            className="letter-textarea"
            placeholder="하고 싶은 말을 적어주세요"
          />
        </div>

        <div className="letter-field checkbox-field">
          <label className="letter-private-label">
            <input
              type="checkbox"
              checked={isPrivate}
              onChange={(e) => setIsPrivate(e.target.checked)}
            />
            비공개로 남기기
          </label>
        </div>

        <button
          type="submit"
          disabled={submitting || alreadySent}
          className={`letter-submit ${submitting ? 'fancy' : ''}`}
        >
          {alreadySent ? '오늘은 이미 보냈어요' : submitting ? '보내는 중...' : '보내기'}
        </button>
      </form>

      {showConfirm && (
        <div className="letter-confirm-popup">
          <div className="popup-box">
            <p className="popup-title">{name || 'Kage'}님, KOIRO로 편지를 보낼까요?</p>
            {isPrivate && <p className="private-indicator">🔒 이 편지는 비공개로 전송됩니다.</p>}
            <p className="popup-preview">"{message}"</p>
            <div className="popup-actions">
              <button onClick={handleConfirmSubmit} className="popup-button">
                네, 보낼게요
              </button>
              <button onClick={() => setShowConfirm(false)} className="popup-cancel">
                아니요, 다시 쓸래요
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default LetterForm;
